/*
 * Add to cart - instant feedback + navigation watchdog
 * ----------------------------------------------------
 * WHY: cart page mode replaced the slide-out drawer with a redirect to /cart.
 * A redirect gives no visual response at the moment of the click, so on a slow
 * connection the button looks dead for several seconds and shoppers report
 * "Add to cart does nothing" and tap again. Testing confirmed the item IS
 * added and the redirect DOES happen - it is the silence in between that reads
 * as breakage.
 *
 * WHAT:
 *   1. Immediate feedback - a thin progress bar plus a busy state on the
 *      button, applied synchronously on submit so there is zero dead time.
 *   2. Watchdog - if nothing has navigated after NAV_DELAY, this navigates to
 *      /cart itself. That covers any product template whose script never opens
 *      the drawer (and therefore never trips the page-mode redirect).
 *
 * SAFETY:
 *   - Never calls preventDefault, so the theme's own submit path is untouched.
 *   - If /cart/add.js returns an error (sold out, inventory), the watchdog is
 *     cancelled so the shopper stays put and sees the theme's error message.
 *   - Payment / GoKwik express buttons are ignored, and an open GoKwik modal
 *     cancels the watchdog, so express checkout is never interrupted.
 *
 * 2026-08-28 - QUICK ADD NO LONGER LEAVES THE PAGE
 *   The watchdog used to cancel only when the add FAILED. On success it let the
 *   timer run, so three seconds after a card quick-add the shopper was pulled
 *   to /cart - even though tradeuno-cart-page-mode.js had already performed the
 *   add over fetch and repainted the badge. Two scripts, one adding silently
 *   and one navigating on top of it.
 *
 *   The watchdog is now cancelled on ANY completed /cart/add response, success
 *   or failure. Tapping the bag icon on a product card adds the item and leaves
 *   the shopper where they are; the header count is their confirmation.
 *
 *   The timer still fires when NO /cart/add request is seen at all, which is the
 *   case this watchdog was written for - a genuine native form post that nothing
 *   intercepted. That safety net is unchanged.
 *
 * TO REVERT: delete the <script> tag for this file from layout/theme.liquid.
 */
(function () {
  var NAV_DELAY = 3000;
  var BAR_ID = 'tu-atc-progress';
  var STYLE_ID = 'tu-atc-progress-style';

  var EXPRESS_SELECTOR =
    '.shopify-payment-button, #gokwik-buy-now, .gokwik-checkout, [id*="gokwik"], [class*="gokwik"]';

  var timer = null;
  var busyButton = null;
  var failed = false;

  function cartUrl() {
    var base = '/';
    try {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        base = window.Shopify.routes.root;
      }
    } catch (e) {}
    if (base.charAt(base.length - 1) === '/') base = base.slice(0, -1);
    return base + '/cart';
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent =
      '#' + BAR_ID + '{position:fixed;top:0;left:0;height:3px;width:0;z-index:2147483000;' +
      'background:#C5A02B;transition:width .45s ease-out;pointer-events:none}' +
      '[data-tu-atc-busy]{opacity:.75;cursor:progress}';
    document.head.appendChild(s);
  }

  function showBar() {
    injectStyles();
    var bar = document.getElementById(BAR_ID);
    if (!bar) {
      bar = document.createElement('div');
      bar.id = BAR_ID;
      document.body.appendChild(bar);
    }
    bar.style.width = '0';
    // Force a reflow so the transition runs from 0.
    void bar.offsetWidth;
    bar.style.width = '75%';
  }

  function hideBar() {
    var bar = document.getElementById(BAR_ID);
    if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
  }

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.setAttribute('data-tu-atc-busy', '');
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('data-tu-atc-busy');
      btn.removeAttribute('aria-busy');
    }
  }

  function gokwikOpen() {
    var m = document.querySelector('#gokwik-modal-wrapper, .gk-iframe');
    if (!m) return false;
    var cs = window.getComputedStyle(m);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  function cancel() {
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
    hideBar();
    setBusy(busyButton, false);
    busyButton = null;
  }

  function go() {
    timer = null;
    if (failed || gokwikOpen()) {
      cancel();
      return;
    }
    var url = cartUrl();
    if (window.location.pathname !== url) {
      window.location.href = url;
    } else {
      cancel();
    }
  }

  // Watch the add request. A completed add - success or failure - means the
  // shopper stays put, so the watchdog is stood down either way. On failure the
  // theme shows its own error; on success the header count is the confirmation.
  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}

      var promise = originalFetch.apply(this, arguments);

      if (url.indexOf('/cart/add') !== -1) {
        promise
          .then(function (res) {
            if (!res || !res.ok) failed = true;
            cancel();
          })
          .catch(function () {
            failed = true;
            cancel();
          });
      }

      return promise;
    };
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || typeof form.getAttribute !== 'function') return;

      var action = form.getAttribute('action') || '';
      if (action.indexOf('/cart/add') === -1) return;

      var submitter = e.submitter || null;
      if (submitter && submitter.closest && submitter.closest(EXPRESS_SELECTOR)) return;
      if (gokwikOpen()) return;

      failed = false;
      busyButton = submitter || form.querySelector('[type="submit"]');

      setBusy(busyButton, true);
      showBar();

      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(go, NAV_DELAY);
    },
    true
  );

  // If the page is restored from bfcache, clear any stale busy state.
  window.addEventListener('pageshow', cancel);
})();
